export default "__VITE_ASSET__RbuCPirW__"